import tmhRequest from '@/config/tmhRequest'

export default {
  searchListDataDictionary: function ( data) {
    return tmhRequest({
      url: '/system/tmh/datadictionary/searchlistdatadictionary',
      method: 'post',
      params: data,
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/tmh/system/datadictionary.js